import React from 'react'
import { dayjs } from '@mobi/utils'
import { NoticeBox } from '@core/Components/NoticeBox'
import { DetailsTextWrapper, DetailsWrapper } from '../TakeABreak.styles'
import { trackTakeABreakAlreadyActive } from '../helpers/analytics'

const TakeABreakActive: React.FC<{
  accountNumber: number
  endDate: Date
  justPostedAccountToTakeABreak: boolean
}> = ({ accountNumber, endDate, justPostedAccountToTakeABreak }) => {
  React.useEffect(() => {
    if (!justPostedAccountToTakeABreak) {
      // trigger event if active and NOT after a post to set tab
      trackTakeABreakAlreadyActive({ accountNumber, endDate })
    }
  }, [accountNumber, endDate, justPostedAccountToTakeABreak])

  return (
    <DetailsWrapper>
      <NoticeBox title='You have opted to Take a Break.' noticeBoxType='Info' hasBorder />
      <DetailsTextWrapper data-testid='end-date-message'>
        Your Take a Break will end at {dayjs.utc(endDate).local().format('hh:mm a MMM Do, YYYY')}
      </DetailsTextWrapper>
    </DetailsWrapper>
  )
}

export default TakeABreakActive
